import React from "react";
import { 
  Bar, Line, Pie, Doughnut, Radar, PolarArea, Scatter, Bubble 
} from "react-chartjs-2";
import { 
  Chart as ChartJS, CategoryScale, LinearScale, BarElement, LineElement, PointElement, ArcElement, 
  RadarController, Tooltip, Title, Legend, 
  RadialLinearScale
} from "chart.js";

// Register components
ChartJS.register(
  CategoryScale, LinearScale, BarElement, LineElement, PointElement, ArcElement, 
  RadarController, Tooltip, Title, Legend,RadialLinearScale
);

const BarChart = () => {
  const chartOptions = { responsive: true, plugins: { legend: { position: "top" } } };

  const barData = { labels: ["A", "B", "C"], datasets: [{ label: "Bar", data: [12, 19, 3], backgroundColor: ["red", "blue", "green"] }] };
  const lineData = { labels: ["Jan", "Feb", "Mar"], datasets: [{ label: "Line", data: [30, 45, 28], borderColor: "blue", backgroundColor: "rgba(0,0,255,0.1)" }] };
  const pieData = { labels: ["Red", "Blue", "Green"], datasets: [{ label: "Pie", data: [10, 20, 30], backgroundColor: ["red", "blue", "green"] }] };
  const doughnutData = { labels: ["Rent", "Food", "Bills"], datasets: [{ label: "Doughnut", data: [500, 200, 300], backgroundColor: ["purple", "orange", "green"] }] };
  const radarData = { labels: ["Speed", "Strength", "Agility"], datasets: [{ label: "Radar", data: [8, 6, 7], backgroundColor: "rgba(255, 99, 132, 0.5)", borderColor: "red" }] };
  const polarData = { labels: ["Asia", "Europe", "America"], datasets: [{ label: "Polar", data: [40, 30, 20], backgroundColor: ["red", "blue", "green"] }] };
  const scatterData = { datasets: [{ label: "Scatter", data: [{ x: 10, y: 20 }, { x: 15, y: 10 }, { x: 20, y: 25 }], backgroundColor: "red" }] };
  const bubbleData = { datasets: [{ label: "Bubble", data: [{ x: 10, y: 20, r: 10 }, { x: 15, y: 10, r: 15 }], backgroundColor: "blue" }] };

  return (
    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px", padding: "20px" }}>
      <div><h3>Bar Chart</h3><Bar data={barData} options={chartOptions} /></div>
      <div><h3>Line Chart</h3><Line data={lineData} options={chartOptions} /></div>
      <div><h3>Pie Chart</h3><Pie data={pieData} options={chartOptions} /></div>
      <div><h3>Doughnut Chart</h3><Doughnut data={doughnutData} options={chartOptions} /></div>
      <div><h3>Radar Chart</h3><Radar data={radarData} options={chartOptions} /></div>
      <div><h3>Polar Area Chart</h3><PolarArea data={polarData} options={chartOptions} /></div>
      <div><h3>Scatter Chart</h3><Scatter data={scatterData} options={chartOptions} /></div>
      <div><h3>Bubble Chart</h3><Bubble data={bubbleData} options={chartOptions} /></div>
    </div>
  );
};

export default BarChart;
